export default __webpack_public_path__ + "static/media/printing-block.6ab287b7.png";